module.exports = __webpack_public_path__ + "images/6f59952103d11d62462443a0c1b5a99e.svg";